import React from "react";
import { Link } from "react-router-dom";
import { FaTwitter, FaDiscord } from "react-icons/fa";
import { SiLinktree } from "react-icons/si";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white w-full">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-[#00df9a]">PRIOR TESTNET</h3>
            <p className="text-gray-400">Automated Yield Optimization for the Future of Decentralized Finance.</p>
            <p className="text-gray-400">London, UK</p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-semibold">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-[#00df9a] transition">Home</Link></li>
              <li><Link to="/faucet" className="text-gray-400 hover:text-[#00df9a] transition">Faucet</Link></li>
              <li><Link to="/swap" className="text-gray-400 hover:text-[#00df9a] transition">Swap</Link></li>
              <li><Link to="/quest" className="text-gray-400 hover:text-[#00df9a] transition">Quest</Link></li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-semibold">Resources</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://docs.google.com/document/d/1QbTljMWQgptiCxkdE1mkbzwXteYk4qAyoekm4Bjuzfs/edit?tab=t.0" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#00df9a] transition"
                >
                  White Paper
                </a>
              </li>
              <li>
                <a 
                  href="https://guild.xyz/prior-protocol-a7e79a" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#00df9a] transition"
                >
                  Guild Address
                </a>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-semibold">Connect With Us</h4>
            <div className="flex space-x-4">
              <a 
                href="https://twitter.com/priorprotocol" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#00df9a] transition text-2xl"
                aria-label="Twitter"
              >
                <FaTwitter />
              </a>
              <a 
                href="https://discord.com/invite/priorprotocol" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#00df9a] transition text-2xl"
                aria-label="Discord"
              >
                <FaDiscord />
              </a>
              <a 
                href="https://linktr.ee/priorprotocol" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#00df9a] transition text-2xl"
                aria-label="Linktree"
              >
                <SiLinktree />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>© {new Date().getFullYear()} PRIOR PROTOCOL TESTNET. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
